import {createContext, useContext} from 'react';
import {AccountFieldsFragment} from '../api/generated';

export const AccountContext = createContext<AccountFieldsFragment | undefined | null>(null);

export const useAccountContext = () => useContext(AccountContext);
